<template>
  <div class="ucp-table">
    <el-table :data="data" style="width: 100%;" border>
      <ucp-table-col v-for="(item, index) in col" :key="index" :col="item"></ucp-table-col>
    </el-table>
  </div>
</template>

<script>
  import UcpTableCol from './ucp-table-col'
  export default {
    name: 'ucp-table',
    props: ['data', 'col'],
    components: {UcpTableCol},
    data() {
      return {

      }
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/ucp-table.vue